import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { AssignDTBPackageToGroupsInput } from '../../_types/dtb';

export default function useManageAssignDTBPackage() {
  const assignToGroups = async (
    orgId: string,
    dtbPackageId: string,
    data: AssignDTBPackageToGroupsInput,
    callback?: (result: any) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/packages/${dtbPackageId}/assign-to-groups`;
    await fetcher({
      url,
      method: 'post',
      body: data,
    })
      .then((result) => {
        if (callback) callback(result);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return { assignToGroups };
}
